import { ProfessionIcon } from './profession-icon';

export const IconMover = () => (
  <ProfessionIcon bg="#E3F2FD">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <rect
        x="1"
        y="4"
        width="14"
        height="12"
        rx="1"
        stroke="#2196F3"
        strokeWidth="1.8"
      />
      <polygon
        points="15 8 19 8 22 11 22 16 15 16 15 8"
        stroke="#2196F3"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="5.5" cy="18.5" r="2.5" stroke="#2196F3" strokeWidth="1.8" />
      <circle cx="17.5" cy="18.5" r="2.5" stroke="#2196F3" strokeWidth="1.8" />
    </svg>
  </ProfessionIcon>
);
